import { Link } from "react-router-dom";
import AnimationOnScroll from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import BackArrow from "../assets/images/back-arrow.svg";
import CameraIcon from "../assets/images/camera-icon.svg";
import TakePhoto from "../assets/images/take-photo.svg";
import UploadPhoto from "../assets/images/upload-photo.svg";

const CaptureType = () => {
  return (
    <section className="pt-2 flex flex-col tab-screen">
      <div className="px-6">
        <div className="flex items-start mb-5 w-full relative z-50">
          <Link
            to={-1}
            className=" w-9 h-9 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
          >
            <img src={BackArrow} alt="" />
          </Link>
          <div className="ml-4 -mt-1">
            <h2 className="text-xl font-medium text-white">
              Dental <span className="text-secondary">Scan</span>
            </h2>
            <p className="text-xs text-white">
              Comprehensive oral health analysis
            </p>
          </div>
        </div>
      </div>

      <div className="circle-blur w-[80%] lg:w-[60%] md:w-[60%] h-64 mx-auto mt-10 blur-[100px] absolute left-0 right-0"></div>

      <div className="px-6 w-full mx-auto relative z-50">
        <h2 className="text-lg lg:text-xl md:text-xl font-semibold text-secondary text-left mb-2 leading-6 mt-2 lg:mt-8 md:mt-8">
          How would you like to capture photos?
        </h2>

        <p className="text-[13px] lg:text-sm md:text-sm font-light text-white text-left leading-5 mb-6 lg:mb-12 md:mb-12">
          Choose the method that works best for you.
        </p>
        <div className="grid grid-cols-2 gap-4">
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <div className="bg-[#1D1D1D]/70 rounded-[20px] flex flex-row justify-between items-center p-4 mb-3">
              <div className="w-10 h-10 bg-secondary rounded-lg mr-2 flex flex-row justify-center items-center">
                <img src={CameraIcon} className="w-6 h-6" alt="" />
              </div>
              <div className="w-8/12 lg:w-9/12 md:w-9/12">
                <h2 className="text-sm lg:text-lg md:text-lg font-semibold text-secondary mb-1">
                  Take My Own Photos
                </h2>
                <p className="text-xxs lg:text-xs md:text-xs font-light text-white leading-3">
                  Use your device camera to capture teeth photos yourself.
                </p>
              </div>
              <Link
                to="/dental-analyzer"
                className="w-8 h-8 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
              >
                <img src={BackArrow} className="rotate-180 w-3" alt="" />
              </Link>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <div className="bg-[#1D1D1D]/70 rounded-[20px] flex flex-row justify-between items-center p-4 mb-3">
              <div className="w-10 h-10 bg-secondary rounded-lg mr-2 flex flex-row justify-center items-center">
                <img src={TakePhoto} className="w-6 h-6" alt="" />
              </div>
              <div className="w-8/12 lg:w-9/12 md:w-9/12">
                <h2 className="text-sm lg:text-lg md:text-lg font-semibold text-secondary mb-1">
                  Get Help Taking Photos
                </h2>
                <p className="text-xxs lg:text-xs md:text-xs font-light text-white leading-3">
                  Have someone assist you in taking clearer, better-positioned
                  photos.
                </p>
              </div>
              <Link
                to="/assistant-instructions"
                className="w-8 h-8 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
              >
                <img src={BackArrow} className="rotate-180 w-3" alt="" />
              </Link>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <div className="bg-[#1D1D1D]/70 rounded-[20px] flex flex-row justify-between items-center p-4 mb-3">
              <div className="w-10 h-10 bg-secondary rounded-lg mr-2 flex flex-row justify-center items-center">
                <img src={UploadPhoto} className="w-6 h-6" alt="" />
              </div>
              <div className="w-8/12 lg:w-9/12 md:w-9/12">
                <h2 className="text-sm lg:text-lg md:text-lg font-semibold text-secondary mb-1">
                  Upload Existing Photos
                </h2>
                <p className="text-xxs lg:text-xs md:text-xs font-light text-white leading-3">
                  Select photos from your gallery or files for analysis.
                </p>
              </div>
              <Link
                to="/dental-analyzer"
                className="w-8 h-8 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
              >
                <img src={BackArrow} className="rotate-180 w-3" alt="" />
              </Link>
            </div>
          </AnimationOnScroll>
        </div>
      </div>

      {/* <Link to={-1} className="block mt-4 text-sm font-medium  text-white">
      Back
    </Link> */}
    </section>
  );
};

export default CaptureType;
